import { ClipboardCopy } from './views/ClipboardCopy';

const Layout = () => <ClipboardCopy />;

export default Layout;
